/**
 * Converts a skill name to a URL-friendly slug: lowercase, spaces to hyphens,
 * and all other non-URL-friendly characters removed.
 */
export function skillNameToSlug(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-') // collapse multiple hyphens
    .replace(/^-|-$/g, ''); // trim leading/trailing hyphens
}
